import { useContext } from 'react';
import { MMDDYYYY } from '../../../JS/Common';
import useConfig from '../../../Hooks/useConfig';

export default function StaticContent(props) {
    const { student, primary_text, dcc_module_text, brought_to_you_by_text, small_student, school,
        twenty_percent_off_text, dcc_third_party_image, organization } = useConfig();

    function scrollToSignUp() {
        const element = document.getElementById("signUpForm");
        element.scrollIntoView({ behavior: "smooth" });
    }

    return (
        <>
            <div className="row pt-3 pb-3 align-items-center">
                <div className='col-md-12 text-center'>
                    {props.SchoolLogo &&
                        <img src={props.SchoolLogo} className="logo-icon" alt="logo icon" style={{ maxHeight: '70px', maxWidth: '70px' }} />
                    }
                </div>
            </div>
            <div className="row pt-3 pb-3 align-items-center">
                <div className='col-md-12 text-center'>
                    <h4 className='fw-600 primary-text' style={{ color: 'var(--primary-color)' }}>{props.SchoolName}</h4>
                </div>
            </div>
            <div className="greyBox p-4 pe-0">
                <div className='row text-center'>
                    <h4 className='fw-600 primary-text'>{dcc_module_text}</h4>
                    <h6 className='fw-600 secondary-text'>{brought_to_you_by_text}</h6>
                    <label className='text-center secondary-text font-13 col-md-10 offset-md-1' style={{ color: "#4C5258", fontSize: "13px" }}>About 1 in 3 {small_student} break their device each year. The average chromebook repair costs between $60–$200. This program takes care of repairs all year long, no matter how big the damage. No surprise bills. No hassle.</label>
                    <button className='col-md-2 offset-md-5 GetStarted mt-4 mb-1 cursor-pointer secondary-text' onClick={scrollToSignUp}>Join Now</button>
                    <label className='font-14 fw-600 secondary-text redText'>
                        {(() => {
                            const today = new Date();
                            const regDate = new Date(props.registrationDate);

                            if (!props.registrationDate) return 'Registration ends on -';

                            // Check if registration date is in the past
                            if (regDate < today.setHours(0, 0, 0, 0)) {
                                return `Registration ended as of 11:59pm EST ${MMDDYYYY(props.registrationDate)}`;
                            } else {
                                return `Registration ends at 11:59pm EST ${MMDDYYYY(props.registrationDate)}`;
                            }
                        })()}
                    </label>
                    <label className='mt-4 secondary-text fw-bold' style={{ color: "#4C5258", fontSize: "16px" }}>Unlimited Repairs | {twenty_percent_off_text} | Repair History | Fast Repairs | Customer Support</label>
                </div>
            </div>
            <div className='my-5 col-12 text-center'>
                <h4 className='fw-600 mb-3 primary-text'>Repairs Included</h4>
                <img src={dcc_third_party_image} className='img-fluid' />
            </div>
            <div className='row pt-3'>
                <div className='col-md-10 offset-md-1 m-auto py-3 text-justify'>
                    <div className='col-md-12 text-center'>
                        <h4 className='fw-600 primary-text'>The Repair Process is Simple</h4>
                    </div>
                    <label className='secondary-text'>Device Club runs from the first to the last day of the {organization} year, giving you peace of mind.
                    </label>
                    <ol className='secondary-text'>
                        <li className='claim-process-content mt-4'>
                            If your {small_student}’s device is damaged, they can bring it to the {school}’s designated tech support location (usually the technology department).
                            <br />{organization} staff will handle the claim and work with {primary_text} to arrange pickup and repair.
                        </li>
                        <li className='claim-process-content mt-3'>Repairs are quick, and devices are returned to the {school}’s tech team for easy distribution back to {small_student}.</li>
                        <li className='claim-process-content mt-3'>For questions, please contact your {school}’s technology department.</li>
                    </ol>
                </div>
            </div>
        </>
    )
}
